import { Text, View } from "react-native";
import { StyleSheet } from "@/utils/appStyleSheet";
import React from "react";
import { FontFamilies } from "@/constants/Typography";
import useUserStore from "@/store/user";

const YourPlan = () => {
  const { isFreePlan } = useUserStore();

  return (
    <View>
      <Text style={styles.title}>Your Sparrow Plan</Text>
      <Text style={styles.subtitle}>
        {isFreePlan ? "Free Plan" : "Unlimited Plan"}
      </Text>
    </View>
  );
};

export default YourPlan;

const styles = StyleSheet.create({
  title: {
    fontSize: 17,
    fontFamily: FontFamilies.Inter.SemiBold,
    color: "#1F2937",
    marginBottom: 8,
    lineHeight: 24,
  },
  subtitle: {
    fontSize: 13,
    fontFamily: FontFamilies.InterTight.Regular,
    color: "#161D14",
    marginBottom: 12,
  },
});
